import ManageKeywordNotesTypeSubType from './manageKeywordNotesTypeSubType'
export default ManageKeywordNotesTypeSubType
